import { Container, Box, Typography, SpeedDial, SpeedDialAction, ButtonGroup, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router';
import AddIcon from '@mui/icons-material/Add';
import ListComponent from '../components/ListComponent';
import { useMediaQuery } from '@mui/material';
import FilterEquipmentComponent from '../components/FilterEquipmentComponent';
import ListMasiveComponent from '../components/ListMasiveComponent';
import { useUtiles } from '../../../../shared/context/utilesContext';
import FilterListIcon from '@mui/icons-material/FilterList';
import UploadIcon from '@mui/icons-material/Upload';
import { useEquipment } from '../../../../shared/context/equipmentContext';
import { useEffect } from 'react';
import { useAbility } from '../../../../shared/context/AbilityContext';

export default function ListEquipmentsView() {
    const theme = useTheme()
    const navigate = useNavigate()
    const isMobile = useMediaQuery('(max-width: 600px)')
    const { toogleOpenSilder } = useUtiles()
    const {resetEquipment } = useEquipment()

    const ability = useAbility();
    useEffect(() => {
        if (!ability.can('read', 'ASSETS.EQUIPMENTS')) {
            navigate('/')
        }
    }, [ability])

    useEffect(() => {
        resetEquipment() 
    }, [])
 
    return (
        <Container maxWidth="xl"> 
            <Box sx={{
                borderRadius: '10px',
                backgroundColor: theme.palette.background.paper,
                padding: '10px 20px',
                position: 'relative'
            }}>
                <Typography variant="h6" sx={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    fontSize: '20px',
                }}>
                    Lista de Equipos
                </Typography>


                <Box sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center'
                }}>

                    {!isMobile && (
                        <ButtonGroup>
                            <Button startIcon={<FilterListIcon />} onClick={() => toogleOpenSilder(<FilterEquipmentComponent type_asset="equipments" />, 400, 'Filtros')}>
                                Filtros
                            </Button>
                            {ability.can('create', 'ASSETS.EQUIPMENTS') && <Button startIcon={<UploadIcon />} onClick={() => toogleOpenSilder(<ListMasiveComponent />, 600, 'Cargar Masivo')}>
                                Importar
                            </Button>}
                        </ButtonGroup>)}

                    {isMobile && (
                        <Button startIcon={<FilterListIcon />} onClick={() => toogleOpenSilder(<FilterEquipmentComponent type_asset="equipments" />, 600, 'Filtros')} variant="outlined">
                            Filtros
                        </Button>
                    )}
                </Box>


                <ListComponent />


               {ability.can('create', 'ASSETS.EQUIPMENTS') && <SpeedDial
                    ariaLabel="Add"
                    sx={{ position: 'absolute', bottom: isMobile ? 80 : 30, right: 8 }}
                    icon={<AddIcon />}
                    direction="right"
                    openIcon={<AddIcon />}
                    onClick={() => navigate('/activos/equipos/crear')}
                />}

            </Box>



        </Container>
    )
}